import Image from 'components/molecules/Image';
import slearnImg from './slearn.png';
import { ImageProps } from 'next/legacy/image';

function SlearnLogo(props: Omit<ImageProps, 'src' | 'alt'>) {
  return <Image width={100} height={100 * (235 / 511)} {...props} src={slearnImg} alt="서울런 로고" />;
}

export default SlearnLogo;
